import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border: 0.5px solid #c9c9c9;
  border-radius: 8px;
  padding: 20px 0px 20px 20px;

  &:nth-child(1n) {
    margin-bottom: 20px;
  }

  .modal-content {
    border-radius: 15px !important;
  }
`;

export const EmployeeName = styled.span`
  font-size: 18px;
  color: #000FFF;
`;

export const DetailsContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

export const SubDetailsContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  justify-content:flex-start;
  align-items: center;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const DetailBadge = styled.div`
  width: auto;
  height: auto;
  background-color: #000FFF;
  padding: 2px 15px;
  color: #ffffff;
  font-size: 12px;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;

  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;

  img {
    margin-left: 10px;
    margin-right: -10px;
    width: 12px;
    height: 12px;
  }
`;

export const DateContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 40px;

  @media (max-width: 1000px) {
    margin-right: 15px;
  }
`;

export const DateLabel = styled.span`
  color: #969696;
  font-size: 12px;
`;

export const Date = styled.span`
  color: #000FFF;
  font-size: 12px;
`;

export const ActionButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 40px;
  cursor: pointer;

  img {
    color: #969696;
    width: 11px;
    margin-right: 5px;
    margin-top: -2px;
  }

  span {
    color: #969696;
    font-size: 12px;
  }

  @media (max-width: 1000px) {
    margin-right: 15px;
  }

  @media (max-width: 767px) {
    padding-bottom:8px;
    margin-right: 0px;
  }

`;
